import { useSuspenseQuery } from "@apollo/client";
import { GET_HR_SETTINGS } from "@/modules/global-wizard/features/save-hr-settings/api/get-hr-settings";

export function useHrSettings() {
  const { data } = useSuspenseQuery(GET_HR_SETTINGS);

  return {
    settings: data?.getHrSettings,
  };
}
